/**
 * Exportação CSV client-side amigável ao Excel pt-BR: BOM UTF-8 para o
 * Excel reconhecer a codificação e `;` como separador (o `,` é decimal na
 * locale). Valores decimais devem chegar já formatados como string com
 * vírgula quando fizer sentido; inteiros podem vir como number.
 */

function escapeCell(value: string | number | null): string {
  if (value === null) return '';
  const s = String(value);
  // Aspas dobradas + célula entre aspas quando há separador, aspas ou quebra.
  if (/[";\n\r]/.test(s)) return `"${s.replace(/"/g, '""')}"`;
  return s;
}

/** Monta o CSV e dispara o download via blob. */
export function downloadCsv(
  filename: string,
  headers: string[],
  rows: (string | number | null)[][]
): void {
  const lines = [headers.map(escapeCell).join(';')];
  for (const row of rows) lines.push(row.map(escapeCell).join(';'));
  const csv = `\uFEFF${lines.join('\r\n')}\r\n`;

  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
